import { API_URL_MEDIA } from "@constants/env";
import { apiMediaToDto } from "@helpers/createMedia.helper";
import { ICreateMedia } from "@interfaces/createMedia";
import apiInstance from "@services/Shared/instanceAxios";

const getMedia = (uuid: string) =>
  apiInstance({
    url: API_URL_MEDIA + uuid,
    transformResponse: (data) =>
      apiMediaToDto(JSON.parse(data as string) as ICreateMedia),
  });

export default getMedia;
